// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> two-zero-five-zero-morningside
// Generated: 2026-11-03T20:39:22.164Z
// Counts: 2 design, 83 content, 40 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At 2050 Morningside, effortless living extends online, too. We're committed to making our digital experience welcoming and accessible to every visitor, so exploring your next home is easy for all.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From the courtyard pool and sky lounge to the coffee bar, wine tap, and fitness center with Echelon Reflect Mirror, 2050 Morningside gives you more ways to reset and recharge. Inside, polished finishes and everyday conveniences—washer and dryer included—keep intown living effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your polished one- or two-bedroom home at 2050 Morningside is just a few clicks away—complete your application today and claim your place in artful intown living between Midtown and Buckhead. From quartz countertops to the sun-splashed pool and sky lounge, effortless Cheshire Bridge Road living is waiting to welcome you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Let's talk—we'd love to hear from you.</strong> Reach out to the 2050 Morningside leasing team for current availability, a personal tour of our artful one- and two-bedroom homes, or directions to our intown address between Midtown and Buckhead.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Set in Atlanta's Lindridge-Martin Manor between Midtown and Buckhead, 2050 Morningside puts a full spread of restaurants, parks, and green escapes within a mile of your door. Explore our list of local favorites to find your new go-to spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare one- and two-bedroom homes ranging from cozy 657-square-foot layouts to spacious 1,151-square-foot, two-bath plans—each finished with quartz or marble countertops, wood-plank flooring, and expansive windows. Explore the cards below to check pricing, square footage, and current availability, then find the intown Atlanta layout that feels right for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Scroll through 2050 Morningside to see it all in one place—sunlit kitchens with marble islands, living rooms opening to private balconies, and bedrooms wrapped in bold accent walls and expansive windows. From the resort-style pool courtyard and teal-toned resident lounge to the rooftop sky lounge with a fire pit and the fully loaded fitness center, every space is captured just as you'll find it.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeintrosection.body": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Artful intown living between Midtown and Buckhead.</strong> At 2050 Morningside, you start with polished one- and two-bedroom apartments in Morningside/Lenox, then add the everyday perks that make the address feel effortless: full-size front-loading washers and dryers, Energy Star stainless steel appliances, quartz or marble countertops, wood-plank flooring, expansive windows, and bathrooms with garden tubs or walk-in showers.</p><p>Beyond your front door, <a class=\"richtext-link\" href=\"/amenities\">community amenities</a> bring more places to reset or recharge, from the sun-splashed pool and courtyard lounge to the sky lounge, coffee bar, fitness center with Echelon Reflect Mirror, parcel lockers, bike storage and repair area, EV charging, and online resident services.</p><p>When you head out, <a class=\"richtext-link\" href=\"/neighborhood\">Cheshire Bridge Road</a> puts dining, shops, and daily essentials close by, with easy access to I-85, I-75, GA-400, Lindbergh Center MARTA, Morningside Nature Preserve, Ansley Mall, Lenox Square, Phipps Plaza, Atlantic Station, Midtown, and Buckhead. Explore your next layout on the <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> page, then see the neighborhood come together in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Cheshire Bridge convenience, intown Atlanta ease.</strong> From 2050 Morningside, step out for southern classics at The Colonnade or a slice at Gino's, then trade the buzz of Cheshire Bridge Road for shaded trails and creek views at Morningside Nature Preserve. Tucked between Midtown and Buckhead in Lindridge-Martin Manor, you're minutes from Lindbergh Center MARTA, I-85, and the shops at Ansley Mall—use the map below to trace your everyday circuit, then <a href=\"/schedule-a-tour\">schedule a tour</a> to feel the location in real time.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Pet-friendly living with room to roam.</strong> Cats and dogs are welcome at 2050 Morningside, where wood-style flooring, an on-site Posh Pet Spa, and a resident courtyard make everyday walks, rinses, and quick cleanups easy. There's no weight limit in the policy—though breed restrictions may apply, so review the details below or ask the leasing team about your pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At 2050 Morningside, your trust matters as much as your comfort. Learn how we collect, use, and safeguard the personal information of our visitors and residents.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f2399-8423-755e-aeb0-c5712f7b2088.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Everything you need, a click away.</strong> Log in to the 2050 Morningside resident portal to pay rent online, submit and track maintenance requests, and stay current on community updates. It's the effortless, always-available way to manage the details—so daily life at this artful intown address stays as polished as your apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Hear what residents are saying.</strong> Residents at 2050 Morningside consistently praise the professional, kind staff, quick maintenance, beautiful apartments, and a clean, dog-friendly community—one calls it simply \"a great place to live.\" Read on for the details that make this address feel effortless, from responsive office support to community events and a dedicated outdoor space for pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Come see 2050 Morningside for yourself.</strong> Book an in-person or virtual tour to walk our polished one- and two-bedroom apartments and take in the pool, sky lounge, and coffee bar—all in an artful intown setting between Midtown and Buckhead.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore everything 2050 Morningside has to offer—from our polished floor plans and community amenities to the Lindridge-Martin Manor neighborhood just between Midtown and Buckhead.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you for reaching out.</strong><br>Your submission has been received, and our leasing team will follow up with you soon. In the meantime, imagine artful intown living at 2050 Morningside—polished one- and two-bedroom apartments between Midtown and Buckhead, with elevated finishes and inviting spaces to reset, recharge, and feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a self-guided look through 2050 Morningside before you ever set foot on-site, from a two-bedroom apartment walkthrough to the fitness center, pool, and sky lounge. Move room to room at your own pace, then browse floor plans or schedule a tour when a space feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bfde-73d3-8b0f-5a156386dd0c.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Modern apartment buildings surrounding a courtyard swimming pool with lounge chairs."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d02ef-cbc9-703c-8dbd-879b09ac41c2.webp"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern gym with rowing machines, spin bikes, treadmills, and weight racks."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bfad-718e-842a-30a6a356427f.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Fitness center with spin bikes and treadmills"
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d5716-3fd4-7739-90ee-0ff17084cf2d.webp"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with fire pit, seating, and bar stools."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d1ca-72f3-8863-51d6e51ad3bf.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Rooftop outdoor lounge area with fire pit, seating, bar seating, and string lights."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Sky Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d02ef-7d56-701c-93f6-3d91541fcfe8.webp"
      }
    }
  },
  "amenitieshomesection.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c2b5-74ea-8390-adcad9797ef3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment complex courtyard with a swimming pool and lounge chairs."
      }
    }
  },
  "amenitieshomesection.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bfad-718e-842a-30a6a356427f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with spin bikes and treadmills"
      }
    }
  },
  "amenitieshomesection.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d1ca-72f3-8863-51d6e51ad3bf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop outdoor lounge area with fire pit, seating, bar seating, and string lights."
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with fire pit, seating, and bar stools."
      },
      "title": {
        "type": "VALUE",
        "customValue": "American Landmark 360 Resident Program"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-7d56-701c-93f6-3d91541fcfe8.webp"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Co-working space with computers and seating areas near large windows with views of trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Gourmet Coffee Bar"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d5716-4d74-7258-8e10-fa59fbd33be0.webp"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern gray kitchen with stainless steel appliances and marble countertops."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Quartz or Marble Countertops"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-dc54-7772-9db5-e1895346bcc2.webp"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop sky lounge with seating, fire pit, and Atlanta city views"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Sky Lounge"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-6e9d-711f-94de-631203b88a4a.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Rise above the day in the sky lounge, our rooftop retreat with a fire pit, comfortable seating, and sweeping views across the Midtown and Buckhead skyline. It's where residents gather to socialize at sunset or simply unwind in the open air—an elevated escape without leaving home.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-dc54-7772-9db5-e1895346bcc2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern gray kitchen with stainless steel appliances and marble countertops."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1ad5-7526-a6b5-91950603479a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Morningside Nature Preserve"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Morningside Nature Preserve"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.atlantatrails.com/hiking-trails/morningside-nature-preserve-atlanta-walking-and-running-trails/"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-3f79-727e-92d0-879c5c5958ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Piedmont Park"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Piedmont Park"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://piedmontpark.org/"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0123-7049-8455-e212fb2b4483.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Skyline Park"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Skyline Park"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://poncecityroof.com/skyline-park"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d5716-0e99-70e0-9f40-82321b0fec9a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex courtyard with a sparkling blue swimming pool surrounded by lounge chairs and modern architecture."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d889-759c-ab2d-7ca129ee6c83.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment gym with weights, punching bag, and cardio machines."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-d833-7039-8559-3d23473d39dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King size bed in a bedroom with a large abstract painting and large windows."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d928-75d9-9956-ee444f1e8e46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a double vanity, large mirror, toilet, and walk-in closet."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d5dc-7568-a0dc-6ee5001dfc2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with blue sofa, marble coffee table, and open-plan kitchen."
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d5dc-7568-a0dc-6ee5001dfc2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-plan model living area at 2050 Morningside with a blue sofa, marble coffee table, and sleek modern kitchen."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-c251-7305-bee9-a01a0497cbcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building exterior with balconies and trees."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d5716-5546-739e-8772-0e17f0334c72.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor courtyard with lounge seating, dining tables, umbrellas, and a pool in the background."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-e748-745e-b339-6598a2dbe7d0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of 2050 Morningside apartments with orange and grey accents, private balconies, and lush surrounding trees."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-ef32-70bf-b0d8-1ecdd20e2bbe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop sky lounge at 2050 Morningside with a fire pit, lounge seating, grills, and a colorful city mural."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-eae8-745c-b0d3-4b6b08de58ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Art-filled resident lobby at 2050 Morningside with a large abstract portrait and modern seating."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-f55e-71a9-88b1-9177020601e4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Building entrance and exterior of 2050 Morningside apartments"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://2050morningside.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d02ef-89f5-706b-839c-70869a2f0346.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment living room and kitchen with a blue sofa, marble coffee table, and modern cabinetry"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://2050morningside.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656808622391296/019d5716-0e99-70e0-9f40-82321b0fec9a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style courtyard with a sparkling blue swimming pool surrounded by lounge chairs"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
